import { AppRoutes } from '@repo/web-utils/app-routes'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'

export function getContentProductUrl({
  locale,
  slug,
  id,
}: {
  locale: string
  slug?: string
  id: string
}) {
  return addOrReplaceLocaleInUrl(`${AppRoutes.PROD}${slug || ''}-${id}/`, locale)
}
